import { render, staticRenderFns } from "./ib-transition-fade.vue?vue&type=template&id=5782254c&lang=pug&"
import script from "./ib-transition-fade.vue?vue&type=script&lang=js&"
export * from "./ib-transition-fade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-transition-fade.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5782254c')) {
      api.createRecord('5782254c', component.options)
    } else {
      api.reload('5782254c', component.options)
    }
    module.hot.accept("./ib-transition-fade.vue?vue&type=template&id=5782254c&lang=pug&", function () {
      api.rerender('5782254c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/transition/ib-transition-fade.vue"
export default component.exports